import { render } from "./SocialMedia.vue?vue&type=template&id=5815e428&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=ts"
export * from "./SocialMedia.vue?vue&type=script&lang=ts"

import "./SocialMedia.vue?vue&type=style&index=0&id=5815e428&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5815e428"

export default script